export default "__VITE_ASSET__B0R2Zcre__"